import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { SessionLockService } from '../../services/session-lock.service';

/** Warns before NF525 §2 locks the terminal. Without it the screen would go
 *  back to the PIN pad mid-order with no explanation. */
@Component({
  selector: 'app-session-lock-warning',
  imports: [CommonModule, NzButtonModule, NzIconModule],
  templateUrl: './session-lock-warning.component.html',
  styleUrls: ['./session-lock-warning.component.scss'],
})
export class SessionLockWarningComponent {
  private readonly sessionLock = inject(SessionLockService);

  readonly seconds = this.sessionLock.secondsBeforeLock;

  stayConnected(): void {
    this.sessionLock.extend();
  }

  lockNow(): void {
    void this.sessionLock.lock('manual');
  }
}
